<script setup lang="ts">
import type { ColorSwatch } from '~/types/colorSwatch'

defineProps<{
    swatch: ColorSwatch
}>()
</script>

<template>
    <span
        aria-hidden="true"
        class="swatch h-4 w-4 inline-flex rounded-full items-center justify-center relative overflow-hidden shrink-0"
        :class="{ 'border border-black': swatch.hex === '#FFFFFF' }"
        :style="swatch.mediaUrl
            ? `background-image: url(${swatch.mediaUrl}); background-size: cover; background-position: center;`
            : `background-color: ${swatch.hex};`"
    />
</template>
